import { render, staticRenderFns } from "./bank_card.vue?vue&type=template&id=6837b519&scoped=true&"
var script = {}
import style0 from "./bank_card.vue?vue&type=style&index=0&id=6837b519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837b519",
  null
  
)

export default component.exports